export default __webpack_public_path__ + "static/media/centralserver.b9250794.svg";